import { render, staticRenderFns } from "./UpcomingMovie.vue?vue&type=template&id=b4dbf544&"
import script from "./UpcomingMovie.vue?vue&type=script&lang=js&"
export * from "./UpcomingMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports